import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Section from '../components/Section';
import Button from '../components/Button';

const NotFoundContainer = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 4rem 0;
`;

const ErrorCode = styled.h1`
  font-size: 8rem;
  font-weight: 700;
  color: var(--blue);
  margin-bottom: 1rem;
  line-height: 1;
`;

const ErrorTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
`;

const ErrorDescription = styled.p`
  font-size: 1.25rem;
  color: var(--gray);
  margin-bottom: 2.5rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
`;

const NotFoundPage = () => {
  return (
    <Layout>
      <SEO 
        title="Página no encontrada | Error 404" 
        description="Lo sentimos, la página que estás buscando no existe o ha sido movida." 
        canonical="https://webabajocoste.es/404"
      />
      
      <Section>
        <NotFoundContainer>
          <ErrorCode>404</ErrorCode>
          <ErrorTitle>Página no encontrada</ErrorTitle>
          <ErrorDescription>
            Lo sentimos, la página que estás buscando no existe, ha sido movida o no está disponible en este momento.
          </ErrorDescription>
          <ButtonGroup>
            <Button as="a" href="/" size="large">
              Volver al inicio
            </Button>
            <Button as="a" href="/contacto" variant="outline" size="large">
              Contactar con soporte
            </Button>
          </ButtonGroup>
        </NotFoundContainer>
      </Section>
    </Layout>
  );
};

export default NotFoundPage; 